export default __webpack_public_path__ + "static/media/travel-care-2.845c3e5c.svg";